export const initialFilters = (regionsOptions?: Option[]) => {
  return {
    responsable: undefined,
    steps: undefined,
    company: undefined,
    noCompanyBusinesses: false,
    companyGroup: undefined,
    sources: [
      {
        value: true,
        libelle: 'OSR',
        type: 'OSR',
      },
      {
        value: true,
        libelle: 'SIROCCO',
        type: 'SIROCCO',
      },
    ],
    statuses: [
      {
        value: true,
        libelle: 'en cours',
        type: 'inprogress',
      },
      {
        value: true,
        libelle: "point d'arrêt",
        type: 'stopped',
      },
    ],
    hasDeclarations: [
      {
        value: true,
        libelle: 'avec',
        type: 'with',
      },
      {
        value: false,
        libelle: 'sans',
        type: 'without',
      },
    ],
    region: regionsOptions && regionsOptions[0],
  }
}
